export { IxSearchBar } from './IxSearchBar.js';
